![Engine Template Preview](https://assets.elevenestudio.me/changelog-idc/engine-template-1.20.webp)

Presentamos el **Motor de Plantillas de Contratos**, una funcionalidad que permite la creación de documentos personalizados para los módulos de Proyectos y Tipos de Proyectos. Esta versión introduce un editor de bloques avanzado, gestión inteligente de variables y generación automática de PDFs profesionales.

## 🚀 Características Principales

### Editor de Bloques Avanzado
- **Editor visual intuitivo** con más de 10 tipos de bloques especializados
- **Soporte multi-columna** para layouts complejos de documentos
- **Herramientas de formato enriquecido** (negrita, cursiva, alineación)
- **Carga y gestión de imágenes** con opciones de visibilidad y posicionamiento
- **Sistema de bloques de firma** integrado

### Gestión Inteligente de Variables
- **Variables de negociación** organizadas por categorías
- **Menú de variables mejorado** con búsqueda y filtrado
- **Integración automática** con datos de clientes, propiedades y negociaciones

### Plantillas implementadas
- **Proyectos**: Lineamientos especiales y Cierre de ventas
- **Tipos de Proyectos**: Acuerdo de compra

<Accordion type="multiple" collapsible className="w-full not-prose">
  <AccordionItem value="item-1">
    <AccordionTrigger>🎯 Funcionalidades del Editor</AccordionTrigger>
    <AccordionContent className="flex flex-col gap-4 text-balance">
      <ul className="list-disc space-y-2 pl-4">
        <li><strong>Bloques de contenido:</strong> Texto, imágenes, tablas, listas numeradas y espaciadores</li>
        <li><strong>Bloques estructurales:</strong> Alertas, separadores y bloques de firma personalizados</li>
        <li><strong>Diseño responsivo:</strong> Posicionamiento sticky de herramientas y navegación optimizada</li>
        <li><strong>Barra de herramientas contextual:</strong> Opciones específicas según el tipo de bloque seleccionado</li>
        <li><strong>Sistema de márgenes:</strong> Configuración avanzada de espaciado y layout</li>
        <li><strong>Vista previa:</strong> Visualización de cambios durante la edición</li>
      </ul>
    </AccordionContent>
  </AccordionItem>
  <AccordionItem value="item-2">
    <AccordionTrigger>📄 Generación de PDFs</AccordionTrigger>
    <AccordionContent className="flex flex-col gap-4 text-balance">
      <ul className="list-disc space-y-2 pl-4">
        <li><strong>Renderizado profesional:</strong> Conversión automática de bloques a PDF con formato profesional</li>
        <li><strong>Soporte para imágenes:</strong> Inclusión automática de imágenes con dimensiones optimizadas</li>
        <li><strong>Tablas avanzadas:</strong> Renderizado de tablas normales y avanzadas con estilos personalizados</li>
        <li><strong>Formato consistente:</strong> Mantenimiento del diseño y estilo corporativo en todos los documentos</li>
        <li><strong>Plantillas especializadas:</strong> Soporte para acuerdos de compra, cierres de venta y órdenes de producción</li>
      </ul>
    </AccordionContent>
  </AccordionItem>
  <AccordionItem value="item-3">
    <AccordionTrigger>🔧 Integración con Proyectos y Tipos de Proyectos</AccordionTrigger>
    <AccordionContent className="flex flex-col gap-4 text-balance">
      <ul className="list-disc space-y-2 pl-4">
        <li><strong>Gestión de plantillas:</strong> Creación, edición y duplicación de plantillas dentro de proyectos y tipos de proyectos</li>
        <li><strong>Validación de formularios:</strong> Verificación antes del envío para garantizar integridad de datos</li>
      </ul>
    </AccordionContent>
  </AccordionItem>
</Accordion>